<!--人才招聘-->
<template>
  <el-row class="hei100 flex-column">
    <div id="topbar">
      <el-row>
        <el-col :span="9">
          <img class="fl" src="../../assets/images/logo2.png" style="height:60px;">
        </el-col>
        <el-col :span="15">
          <el-row class="menu" type="flex">
            <div class="text-right flexson " @click="openUrl(1)">
              <a href="#part1"><span>首页</span></a>
            </div>
            <div class="text-right flexson"  @click="openUrl(2)">
              <a href="#part2"><span>软件业务</span></a>
            </div>
            <div class="text-right flexson"  @click="openUrl(3)">
              <a href="#part3"><span>企业简介</span></a>
            </div>
            <div class="text-right flexson"  @click="openUrl(4)">
              <a href="#part4"><span>企业优势</span></a>
            </div>
            <div class="text-right flexson"  @click="openUrl(5)">
              <a href="#part5"><span>新闻资讯</span></a>
            </div>
            <div class="text-right flexson"  @click="dialogVisible=true">
              <a href="#part6"><span>联系我们</span></a>
            </div>
            <div class="text-right flexson onclick">
              <span>人才招聘</span>
            </div>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <!--  -->
    <el-row class=" " style="padding-bottom:50px;">
      <div class="">
        <img class="block wid100" src="../../assets/part2/rczp.png" alt="">
      </div>
      <el-row class="auto mar-top20" style="width:1320px;">
        <div class="pad20 bgc-gray2">
          <el-row type="flex">
            <div class="flex-son pading-left20">
              <el-row class="">
                <span class=" bgc-blue2 inline-block sub" style="width:8px; height:27px;"></span>
                <span class="fc-2 ft-size29 bold">前端开发</span>
              </el-row>
              <el-row class="hei30 pading-left20">
                <span class="fc-2 ft-size18">工作地点：南昌。你有能力，我有空间，欢迎有志之士加入！</span>
              </el-row>
            </div>
            <div class="fc-wt algincenter">
              <a class=" ft-size18 block join" href="https://www.zhipin.com/job_detail/f32d9f5dda40e0b81n1929m7FVVT.html?ka=comp_joblist_7" target="_blank">申请职位</a>
            </div>
          </el-row>
        </div>
        <div class="pad20 bgc-gray2 mar-top20">
          <el-row type="flex">
            <div class="flex-son pading-left20">
              <el-row class="">
                <span class=" bgc-blue2 inline-block sub" style="width:8px; height:27px;"></span>
                <span class="fc-2 ft-size29 bold">软件工程师</span>
              </el-row>
              <el-row class="hei30 pading-left20">
                <span class="fc-2 ft-size18">工作地点：南昌。你有能力，我有空间，欢迎有志之士加入！</span>
              </el-row>
            </div>
            <div class="fc-wt algincenter">
              <a class=" ft-size18 block join" href="https://www.zhipin.com/job_detail/3ef8edb66d87834a1XB42ty7FFY~.html?ka=comp_joblist_11" target="_blank">申请职位</a>
            </div>
          </el-row>
        </div>
      </el-row>
    </el-row>
    <footerbar></footerbar>
    <el-dialog title="" :visible.sync="dialogVisible" class="newdialog" width="790px" append-to-body>
      <div>
        <el-row style="padding-left:40px;padding-bottom:30px;">
          <img class="fl" src="@/assets/images/logo1.png" style="height:40px;">
        </el-row>
        <el-row>
          <el-col :span="17" style="padding-left:40px;">
            <el-row class="hei40">
              <span class="fc-2 ft-size16">地&emsp;&emsp;址:</span>
              <span class="fc-2 ft-size16">北京市昌平区北清路1号院8号楼14层</span>
            </el-row>
            <!-- <el-row class="hei40">
              <span class="fc-2 ft-size16">邮&emsp;&emsp;箱:</span>
              <span class="fc-2 ft-size16 ">155396138@qq.com&emsp;2627504375@qq.com</span>
            </el-row> -->
            <el-row class="hei40">
              <span class="fc-2 ft-size16">电&emsp;&emsp;话:</span>
              <span class="fc-2 ft-size16 ">15869194531(乐)</span>
            </el-row>
            <!-- <el-row class="hei40">
              <span class="fc-2 ft-size16">商务合作:</span>
              <span class="fc-2 ft-size16 pointer">15079173050(乐)</span>
            </el-row> -->
            <el-row class="hei40">
              <span class="fc-2 ft-size16">网&emsp;&emsp;站:</span>
              <span class="fc-2 ft-size16 pointer">http://www.ylybj.cn</span>
            </el-row>
          </el-col>
          <el-col :span="7">
            <div style=" margin-left:40px; border-left:1px solid #ddd; height:200px;" class=" algincenter">
              <div>
                <el-row class="border">
                  <img class="width100 block" src="@/assets/icon/qrcode.png" alt="">
                </el-row>
                <el-row class="text-center hei30">
                  <span class="fc-2 ft-size16">微信公众号</span>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import footerbar from "../footerbar";
export default {
  name: "joinUs",
  components: { footerbar },
  data() {
    return {
      dialogVisible: false
    };
  },
  mounted() {},
  methods: {
    openUrl(n){
      this.$router.push({path:'/index'})
    },
  },
  destroyed() {},
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/components/basicData/joinUs.vue